import { useFormContext } from "react-hook-form";

import { Modal } from "@pentabd/ui";

import {
  CancelButton,
  SectionTitle,
  SelectEmployee,
  SubmitButton,
} from "@components";

import { ReleaseFormDataType } from "@validations/HRM/release/releaseFormValidation";

interface DeceasedModalType {
  isModalOpen: boolean;
  closeModal: () => void;
  isLoading: boolean;
}

export const DeceasedModal = ({
  isModalOpen,
  closeModal,
  isLoading,
}: DeceasedModalType) => {
  const { watch } = useFormContext<ReleaseFormDataType>();

  return (
    <Modal
      isOpen={isModalOpen}
      overlay={isModalOpen}
      onClose={closeModal}
      closeAble
    >
      <div className="p-10 border-bottom">
        <SectionTitle label="RELEASE_DETAILS.FORM.SEND_BUTTON" />
        <SelectEmployee
          registeredName="reviewerId"
          selectSingleEmployee
          forModal
        />
      </div>
      <div className="p-9 d-flex justify-content-end align-items-center gap-6">
        <CancelButton action={closeModal} loading={isLoading} />
        <SubmitButton
          disabled={typeof watch("reviewerId") !== "number"}
          loading={isLoading}
        />
      </div>
    </Modal>
  );
};
